/**
 * Tests whether a given **string** is made up only numeric characters.
 *
 * @param {string} val - The value which is tested whether it is only made of
 * numeric characters.
 *
 * @returns {boolean} - Whether the value tested was only made of numeric chars.
 */
var isNumeric = function isNumeric(val) {
  if (typeof val !== 'string' || !val.length) {
    return false;
  }

  return !isNaN(parseFloat(val));
};

export { isNumeric };
